module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback2-3fb3ccd9d4725811556cf4f7bcb363e0.jpg";